import React from "react";
import '../../../pricingDashboard/pricingDashboardPages/PricingDashboardTableRow.css';
import Tooltip from "@material-ui/core/Tooltip";
import {CANCEL_EDIT_ENTRY} from "../../../pricingDashboard/constants";
import EditIcon from "@material-ui/icons/Edit";
import { IconButton, TableCell, TextField, Button, Checkbox } from '@material-ui/core';
import ClearIcon from '@mui/icons-material/Clear';
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import { CARRY_FORWARD_OPTIONS, SOURCE_OPTIONS, SUM_RULE_OPTIONS } from '../constants';
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Chip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import {CANCEL} from "../../../global/constants";
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import DeleteIcon from '@material-ui/icons/Delete';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import TextSnippetOutlinedIcon from '@mui/icons-material/TextSnippetOutlined';

class CreditCardBalancesEntryTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            deleteId: "",
            isDeleted: false,
            isDialogOpen: false,
            id: "",
            open:false,
        };
    }

    componentDidMount() {

        let newState = {
            deleteListing: false,
            name: '',
            totalBalance: '0.00',
            source: '',
            category: '',
            carryForwardBalance: 'No',
            sumRule: '',
        }
        this.props.setRowState(newState)


    }

    handleOpen = () => {
        this.setState({ isDialogOpen: true });
    };

    handleClose = () => {
        this.setState({ isDialogOpen: false });
    };


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.listingIdBeingEdited !== this.props.listingIdBeingEdited) {
            if (this.props.listingIdBeingEdited === this.props.row.id) {
                this.props.setRowState({
                    id: this.props.row.id,
                    name: this.props.row.name,
                    totalBalance: this.props.row.totalBalance,
                    source: this.props.row.source,
                    category: this.props.row.category,
                    carryForwardBalance: this.props.row.carryForwardBalance || 'No',
                    sumRule: this.props.row.sumRule,

                })
            }
        }
    }


    handleCancel = (row) => {
        if (row.id === '') {
            const newEntry = this.props.creditCardBalancesSummary.filter(item => item.id !== '');

            // Update the outstandingChequesSummary state with the filtered list
            this.setState(prevState => {
                this.props.setCreditCardBalancesEntries(newEntry);
            });
        }

        this.props.setListingIdBeingEdited("");
        this.props.setRowState({
            id: '',
            name: '',
            totalBalance: '',
            source: '',
            category: '',
            carryForwardBalance: '',
            sumRule: '',
        });

    }


    handleConfirm = (row) => {
        let state = this.props.getRowState()
        if (!state.name || !state.totalBalance || !state.carryForwardBalance) {
            return;
        }

        this.props.setListingIdBeingEdited("")
        const request = {
            source: state.source,
            category: state.category,
            carryForwardBalance: state.carryForwardBalance,
            sumRule: state.sumRule,
            id: row.id,
            name: state.name,
            totalBalance: String(state.totalBalance).replace(/,/g, ''),
            ledgerId: this.props.ledgerId,
            currency: this.props.currency,
            year: this.props.year,
            ledgerType: this.props.ledgerType,
            type: "creditCardBalances"
        };
        this.props.setRowState({
            name: '',
            totalBalance: '',
        })

      this.props.updateEntry(request);
    }


    handleDeleteEntry = () => {

        const data = {
            ledgerId: this.props.ledgerId,
            id: this.state.deleteId,
            year: this.props.year,
            currency: this.props.currency,
            type: "creditCardBalances"
        };

        this.setState({ isDialogOpen: false, deleteId: ""},()=>{
            this.props.deleteEntry(data);
        });
    }

    handleSaveNote = (row, newNote) => {
        const updatedSummary = (this.props.creditCardBalancesSummary || []).map(entry =>
          entry.id === row.id ? { ...entry, note: newNote } : entry
        );
        this.props.setCreditCardBalancesEntries(updatedSummary);

        const request = {
            source: row.source,
            category: row.category,
            carryForwardBalance: row.carryForwardBalance,
            sumRule: row.sumRule,
            id: row.id,
            name: row.name,
            totalBalance: String(row.totalBalance ?? '').replace(/,/g, ''),
            note: newNote,
            ledgerId: this.props.ledgerId,
            currency: this.props.currency,
            year: this.props.year,
            ledgerType: this.props.ledgerType,
            type: "creditCardBalances"
        };
        this.props.updateEntry(request);
    }

    handleOpenNotes = (row) => {
        if (typeof this.props.onOpenNotesDialog === 'function') {
            this.props.onOpenNotesDialog(row.note || '', (newNote) => this.handleSaveNote(row, newNote));
        }
    }

    getEditingCancelConfirm = (row) => {
        return <>
            <div style={{display:"flex", justifyContent:"left"}}>
                <Tooltip title={CANCEL_EDIT_ENTRY}>
                    <IconButton onClick={() => this.handleCancel(row)}>
                        <ClearIcon
                            fontSize='small'
                            color='error'
                        />
                    </IconButton>
                </Tooltip>
            </div>
        </>
    }



    formatBalance = (balance) => {
        const validBalance = parseFloat(balance);
        if (isNaN(validBalance)) {
            return '0.00';
        }
        return validBalance
          .toFixed(2)
          .toString()
          .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    };



    onBlurHandle = (name, value) => {
        const formattedValue = this.formatBalance(value);
        if (name === 'totalBalance') {
            this.props.setRowState({ totalBalance: formattedValue });
        } else if (name === 'balance') {
            this.props.setRowState({ balance: formattedValue });
        }
    };

    displayBalanceEditingTextField = () => {
        const state = this.props.getRowState();

        return (
          <TextField
            style={{ marginLeft: "-8px", padding: "0" }}
            className="full-width-ledger"
            variant="outlined"
            name={state.row === "Opening Balance" ? "balance" : "totalBalance"}
            label="Amount"
            value={state.row === "Opening Balance" ? state.balance : state.totalBalance || ''}
            onBlur={(e) => this.onBlurHandle(e.target.name, e.target.value)}
            onChange={(e) => {
                const value = e.target.value.replace(/,/g, '')
                if (state.row === "Opening Balance") {
                    this.props.setRowState({ balance: value });
                } else {
                    this.props.setRowState({ totalBalance: value });
                }
            }}
            onPaste={(e) => {
                e.preventDefault(); // Prevent default paste action
                const pastedValue = e.clipboardData.getData('Text').replace(/,/g, ''); // Remove commas
                if (state.row === "Opening Balance") {
                    this.props.setRowState({ balance: pastedValue });
                } else {
                    this.props.setRowState({ totalBalance: pastedValue });
                }
            }}
            error={
              state.row !== "Opening Balance" &&
              (state.totalBalance === '' || state.totalBalance === null || state.totalBalance === undefined)
            }
          />
        );
    };


    displayNameEditingTextField = () => {
        let state = this.props.getRowState()
        return <TextField
            style={{marginLeft:"-8px",padding:"0"}}
            className="full-width-ledger"
            variant="outlined"
            name="name"
            label="Bank Account"
            value={state.name}
            onChange={(e) => this.props.setRowState({name: e.target.value})}
            error={state.name === '' || state.name === null || state.name === undefined}
        />
    }

    displayCategoryEditingDropdown = () => {
        let state = this.props.getRowState();

        if (state.source === 'Transactions') {
            return (
              <Autocomplete

                className="full-width-ledger-category"
                multiple
                open={this.state.open}
                value={
                    Array.isArray(state.category)
                      ? state.category.map((cat) =>
                        this.props.categories.find((category) => category.name === cat) // Find category objects from names
                      ).filter(Boolean) // Ensure no undefined values
                      : [] // Fallback to an empty array if state.category is not an array
                }
                options={(this.props.categories || []).sort((a, b) => a.displayOrder - b.displayOrder)} // Sorting categories
                getOptionLabel={(option) => option.name || ''}
                autoHighlight={true}
                renderTags={(value) => {
                    if (value.length > 1) {
                        return (
                          <div style={{ width:'60px', display: 'inline-flex', flexWrap: 'nowrap', alignItems: 'center' }}>

                              <Chip
                                variant="outlined"
                                size="small"
                                style={{ borderColor: "#acd685", margin: "1px 6px 1px 0", fontSize: "12px" }}
                                label={value[0].name} // Display the first category
                              />
                              <Chip
                                variant="outlined"
                                size="small"
                                style={{ borderColor: "#acd685", margin: "1px 6px 1px 0", fontSize: "12px" }}
                                label="..." // Display "..." for additional categories
                              />

                          </div>
                        );
                    }
                    return value.map((option) => (
                      <Chip
                        variant="outlined"
                        size="small"
                        style={{ borderColor: "#acd685", margin: "1px 6px 1px 0", fontSize: "12px" }}
                        label={option.name}
                      />
                    ));
                }}
                renderOption={(option, { selected }) => (
                  <React.Fragment>
                      <Checkbox
                        icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                        checkedIcon={<CheckBoxIcon fontSize="small" />}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option.name}
                  </React.Fragment>
                )}
                onOpen={() => { this.setState({ open: true }) }}
                onClose={(event, reason) => {
                    reason === 'blur' ? this.setState({ open: false }) : this.setState({ open: true })
                }}
                name="category"
                onChange={(event, value) => {
                    this.props.setRowState({
                        category: value.map((cat) => cat?.name), // Store just the category names (strings) in the state
                    })
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Category"
                    InputLabelProps={{ shrink: true }}
                    variant="outlined"
                    name="category"
                  />
                )}
              />

            );
        }

        return null;
    };

    displaySourceEditingDropdown = () => {
        let state = this.props.getRowState();
        const FILTERED_SOURCE_OPTIONS = SOURCE_OPTIONS.filter(option => option !== "Ledgers");
        return (
          <Autocomplete
            className="full-width-ledger"
            options={FILTERED_SOURCE_OPTIONS}
            getOptionLabel={(option) => option}
            value={state.source || null}
            onChange={(e,value) => this.props.setRowState({ source: value })}
            renderInput={(params) =>
              <TextField
                {...params}
                name="source"
                label="Source"
                variant="outlined"
                InputLabelProps={{ shrink: true }}
              />
            }
          />
        );
    }

    displaySumRuleEditingDropdown = () => {
        let state = this.props.getRowState();

        // Only render the dropdown if state.source is 'transactions'
        if (state.source === 'Transactions') {
            return (
              <Autocomplete
                className="full-width-ledger"
                options={SUM_RULE_OPTIONS}
                getOptionLabel={(option) => option}
                value={state.sumRule || null}
                onChange={(e, value) => this.props.setRowState({ sumRule: value })}
                renderInput={(params) =>
                  <TextField
                    {...params}
                    name="sumRule"
                    label="Sum Rule"
                    variant="outlined"
                    required={true}
                    error={state?.sumRule === '' || state?.sumRule === null || state?.sumRule === undefined}
                    InputLabelProps={{ shrink: true }}
                  />
                }
              />
            );
        }

        // Return null or an empty fragment if the condition is not met
        return null;
    }

    displayCarryForwardBalanceEditingDropdown = () => {

        let state = this.props.getRowState();
        return (
          <Autocomplete
            className="full-width-ledger"
            options={CARRY_FORWARD_OPTIONS}
            getOptionLabel={(option) => option}
            value={state.carryForwardBalance || null}

            onChange={(e, value) => this.props.setRowState({ carryForwardBalance: value })}
            renderInput={(params) =>
              <TextField
                {...params}
                name="carryForwardBalance"
                label="Carry Forward Balance"
                variant="outlined"
                required={true}
                error={state.carryForwardBalance === '' || state.carryForwardBalance === null || state.carryForwardBalance === undefined}
                InputLabelProps={{ shrink: true }}
              />
            }
          />
        );
    }


    displayEditingRow = (row) => {
        let state = this.props.getRowState();


        if (row.name === "Total") {
            return null
        }

        return (
          <React.Fragment>
            <TableCell
              style={{
                width: '70px',
                height: '77px',
                padding: '0',
                margin: '0',
              }}
            >
              {this.getEditingCancelConfirm(row)}
            </TableCell>

            <TableCell>
              <div className="rowSpecLedger">
                {this.displayNameEditingTextField()}
                {this.displaySourceEditingDropdown()}
                {this.displayCategoryEditingDropdown()}
                {this.displaySumRuleEditingDropdown()}
                {this.displayCarryForwardBalanceEditingDropdown()}
              </div>
            </TableCell>

            <TableCell>
              <div className="rowSpecLedger">
                {state.source === 'Transactions' ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                    }}
                  >
                    <span style={{ flexShrink: 0 }}>$</span>
                    <span
                      style={{
                        marginLeft: '55px',
                        minWidth: '80px',
                        textAlign: 'right',
                      }}
                    >
                   {state.row === "Opening Balance" ?  this.formatBalance(state.balance) :  this.formatBalance(state.totalBalance)  || ''}
                    </span>
                  </div>
                ) : (
                  this.displayBalanceEditingTextField()
                )}
              </div>
            </TableCell>

            <TableCell>
              <Tooltip title="Save Entry" style={{ marginLeft: '-8px' }}>
                <IconButton onClick={() => this.handleConfirm(row)}>
                  <CheckCircleIcon fontSize="small" color="secondary" />
                </IconButton>
              </Tooltip>
            </TableCell>
          </React.Fragment>
        );
    }

    displayNonEditingRow = (row) => {

        if (this.props.isEditPayable && row.name === "Total") {
            return null
        }

        const isManualEntry = !!(row.carryForwardBalance ?? false) && row.name !== "Total";

        return (
            <React.Fragment>
                {this.props.isEditPayable && row.name !== "Total" && (row.carryForwardBalance ?? false) ? (
                    <TableCell>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Tooltip title={"Edit Entry"}>
                                <IconButton
                                    onClick={() => {
                                        this.props.setHideFilterBox(true);
                                        this.props.setListingIdBeingEdited(row.id);
                                    }}
                                >
                                    <EditIcon fontSize="small" />
                                </IconButton>
                            </Tooltip>
                            <Tooltip title={row.note ? row.note : 'Notes'}>
                                <IconButton onClick={() => this.handleOpenNotes(row)}>
                                    {row.note ? (
                                      <TextSnippetIcon fontSize="small" />
                                    ) : (
                                      <TextSnippetOutlinedIcon fontSize="small" />
                                    )}
                                </IconButton>
                            </Tooltip>
                        </div>
                    </TableCell>
                ) : (
                  <TableCell>
                      {isManualEntry && row.note ? (
                        <Tooltip title={row.note}>
                            <IconButton onClick={() => this.handleOpenNotes(row)}>
                                <TextSnippetIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                      ) : (
                        <IconButton style={{ visibility: 'hidden' }}>
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                      )}
                  </TableCell>
                )}


                <TableCell style={{ textAlign: "right", padding: "5px", paddingRight: "50px", width: "100%", fontWeight: row.name === "Total" ? "bold" : "normal"}}>
                    <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                        {row.name}
                    </div>
                </TableCell>


                <TableCell style={{  textAlign: "right", padding: "5px", paddingRight: "50px", width: "auto",
                    fontWeight: row.name === "Total" ? "bold" : "normal"}}>
                    <div style={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                        <span style={{flexShrink: 0}}>$</span>
                        <span style={{marginLeft: '55px', minWidth: '80px', textAlign: 'right'}}>
                 {row.name === "Opening Balance" ? this.formatBalance(row.balance) :  this.formatBalance(row.totalBalance)}
                </span>
                    </div>
                </TableCell>


                {this.props.isEditPayable && (row.carryForwardBalance ?? false) ? (

                  <TableCell>
                      <IconButton
                        onClick={() => {
                            this.setState({
                                isDeleted: true,
                                deleteId: row.id,
                            },()=>{
                                this.handleOpen()
                            });

                        }}
                      >
                          <DeleteIcon fontSize="small" />
                      </IconButton>


                  </TableCell>

                ) : (
                  <TableCell>
                      <IconButton  style={{ visibility: 'hidden' }}
                      >
                          <DeleteIcon fontSize="small" />
                      </IconButton>
                  </TableCell>
                )}
            </React.Fragment>
        );
    };


    displayListingRow = (listingIdBeingEdited) => {
        if (listingIdBeingEdited === this.props.row.id) {
            return this.displayEditingRow(this.props.row)
        } else {
            return <>
                {this.displayNonEditingRow(this.props.row)}
            </>
        }
    }

    render() {
        return (
            <React.Fragment>
                <Dialog open={this.state.isDialogOpen} onClose={this.handleClose}>
                    <DialogTitle>Confirmation</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            Are you sure you want to delete this entry?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>

                        <div className='save-cancel-buttons'>
                            <Button
                                variant='contained'
                                onClick={this.handleClose}
                            >
                                {CANCEL}
                            </Button>
                            <div className='save-spacing'/>
                            <Button
                                variant='contained'
                                color='primary'
                                onClick={this.handleDeleteEntry}
                            >
                                Delete
                            </Button>
                        </div>

                    </DialogActions>
                </Dialog>
                {this.displayListingRow(this.props.listingIdBeingEdited)}
            </React.Fragment>
        )
    }
}


export default CreditCardBalancesEntryTableRow;